var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 17.1598C8.61 17.1598 8.52 17.1398 8.44 17.1098L1.26 14.2398C0.8 14.0598 0.5 13.6198 0.5 13.1298V4.45984C0.5 4.16984 0.67 3.91984 0.94 3.80984L8.07 0.959844C8.27 0.879844 8.48 0.839844 8.7 0.839844C8.92 0.839844 9.13 0.879844 9.33 0.959844L16.46 3.80984C16.73 3.91984 16.9 4.16984 16.9 4.45984V13.1198C16.9 13.6098 16.6 14.0498 16.15 14.2298L8.96 17.0998C8.88 17.1298 8.79 17.1498 8.7 17.1498V17.1598ZM8 15.4298V7.93984L1.9 5.49984V12.9898L8 15.4298ZM9.4 15.4298L15.5 12.9898V5.49984L9.4 7.93984V15.4298ZM8.7 6.70984L14.32 4.45984L12.45 3.70984L6.83 5.95984L8.7 6.70984ZM4.95 5.20984L10.57 2.95984L8.82 2.25984C8.82 2.25984 8.75 2.23984 8.71 2.23984C8.67 2.23984 8.63 2.23984 8.6 2.25984L3.08 4.45984L4.95 5.20984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/products-icon.bb0bbb1b79b80e199853f7af8fd49129.svg";
export { ForwardRef as ReactComponent };